import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

const SKELETON_CARD_COUNT = 6;

const HeaderBar = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: theme.palette.primary.main,
    padding: '8px'
}));

const InfoRowContainer = styled(Box)({
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
});

const ImageGrid = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 260px)',
    justifyContent: 'center',
    gap: '36px',
    padding: '16px',
    [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        padding: '8px'
    }
}));

function SkeletonCard() {
    return (
        <Box sx={{ width: 260 }}>
            <Box sx={{ position: 'relative' }}>
                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    width={260}
                    height={195}
                    sx={{
                        bgcolor: 'rgba(0, 0, 0, 0.11)',
                        '&::after': {
                            background:
                                'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.06), transparent)'
                        }
                    }}
                />
                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    width={70}
                    height={22}
                    sx={{ position: 'absolute', top: 8, left: 8, borderRadius: '4px' }}
                />
            </Box>
            <Skeleton variant="text" animation="wave" width={130} sx={{ mt: '4px' }} />
        </Box>
    );
}

export function CustomerImageProcessingPageSkeleton() {
    return (
        <Box
            component="section"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
            }}
        >
            <Box
                sx={{
                    borderLeft: '1px solid #ddd',
                    borderRight: '1px solid #ddd',
                    borderBottom: '1px solid #ddd'
                }}
            >
                <HeaderBar>
                    <Skeleton
                        variant="text"
                        animation="wave"
                        width={150}
                        sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}
                    />
                    <Skeleton
                        variant="circular"
                        animation="wave"
                        width={24}
                        height={24}
                        sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}
                    />
                </HeaderBar>

                <InfoRowContainer>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Skeleton variant="text" animation="wave" width={120} height={24} />
                        <Skeleton variant="text" animation="wave" width={90} height={24} />
                        <Skeleton variant="circular" animation="wave" width={24} height={24} />
                        <Skeleton variant="text" animation="wave" width={140} height={24} />
                    </Box>
                    <Skeleton variant="text" animation="wave" width={160} height={24} />
                </InfoRowContainer>

                <ImageGrid>
                    {Array.from({ length: SKELETON_CARD_COUNT }, (_, i) => (
                        <SkeletonCard key={i} />
                    ))}
                </ImageGrid>
            </Box>
        </Box>
    );
}
